import {
  ISsoAuthAPIResponse,
  ISsoAuthValidationPayload,
} from 'types/auth.types';
import { HTTP_METHODS } from '../constants/HttpConstants';
import {
  sendRequestToDoSelectCentralService,
  sendRequestToServerWithCredentials,
} from '../utils/request';

export const getUserIdentityApi = () =>
  sendRequestToDoSelectCentralService({
    method: HTTP_METHODS.GET,
    url: '/gateways/identity',
  });

export const getRecruiterApi = (user_id: number, username: string) =>
  sendRequestToDoSelectCentralService({
    method: HTTP_METHODS.GET,
    url: `/api/v1/recruiter/${user_id}?__env=PLT&__user=${username}`,
  });

export const getModulesApi = () =>
  sendRequestToDoSelectCentralService({
    method: HTTP_METHODS.GET,
    url: `/rpc/get_modules`,
  });

export const getCompanyApi = (company_slug: string, username: string) =>
  sendRequestToDoSelectCentralService({
    method: HTTP_METHODS.GET,
    url: `/api/v1/company/${company_slug}?__env=PLT&__user=${username}`,
  });

export const getQuotasApi = (username: string) =>
  sendRequestToDoSelectCentralService({
    method: HTTP_METHODS.GET,
    url: `/rpc/billing.get_team_quotas?__env=PLT&__user=${username}`,
  });

export const ssoAuthValidation = (payload: ISsoAuthValidationPayload) =>
  sendRequestToServerWithCredentials<ISsoAuthAPIResponse>({
    method: HTTP_METHODS.POST,
    url: '/integrations/validate_redirection_url/',
    data: payload,
  });

export const getCompanyTeamMembersStatsApi = (username: string) =>
  sendRequestToDoSelectCentralService({
    method: HTTP_METHODS.GET,
    url: `rpc/team.get_member_stats?__env=PLT&__user=${username}`,
  });
